




import { Component, Vue } from 'vue-property-decorator'

@Component
export default class News extends Vue {
  private get newsID() {
    return +this.$route.params.newsID
  }
  private mounted() {
    const newsID = this.newsID
    this.$router.replace({
      name: 'master',
    })
      .then(() => {
        this.$bus.$emit('fetchNewsItem', newsID)
      })
  }
}
